import React, { useState, useEffect } from 'react';
   import Login from './components/Login';
   import Dashboard from './components/Dashboard';
   import './App.css';

   function App() {
     const [user, setUser] = useState(null);
     const [loading, setLoading] = useState(true);

     useEffect(() => {
       // Check if user is already logged in
       const token = localStorage.getItem('auth_token');
       const savedUser = localStorage.getItem('user');
       
       if (token && savedUser) {
         setUser(JSON.parse(savedUser));
       }
       setLoading(false);
     }, []);

     const handleLoginSuccess = (userData) => {
       setUser(userData);
     };

     const handleLogout = () => {
       localStorage.removeItem('auth_token');
       localStorage.removeItem('user');
       setUser(null);
     };

     if (loading) {
       return <div className="loading">Loading...</div>;
     }

     if (!user) {
       return <Login onLoginSuccess={handleLoginSuccess} />;
     }

     return (
       <Dashboard user={user} onLogout={handleLogout} />
     );
   }

   export default App;
